module.exports = __webpack_public_path__ + "static/media/giant-humster-run.edea225d.jpg";